import React, { useState, Fragment } from 'react';
import classes from './MultipleChoiceType.module.scss';
import MultipleChoiceOption from './MultipleChoiceOption/MultipleChoiceOption';
import CommonErrorMessage from 'components/FormUI/CommonErrorMessage';

const MultipleChoiceType = ({ index: questionIndex, question, setFieldValue, onRemoveChoice }) => {
  return (
    <div className={classes.options_container}>
      {question?.options?.map((option, index) => {
        return (
          <>
            <MultipleChoiceOption
              setFieldValue={setFieldValue}
              key={option?.id}
              index={index}
              option={option}
              onRemoveChoice={onRemoveChoice}
              questionIndex={questionIndex}
            />
            {option.value.length > 200 && (
              <div>
                <CommonErrorMessage align="left" message="Option should not be more than 200 characters" />
              </div>
            )}
          </>
        );
      })}
    </div>
  );
};

export default MultipleChoiceType;
